import script from "./CustomerForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerForm.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerForm.vue?vue&type=style&index=0&id=e7c9d4f8&scoped=true&lang=scss"
import "./CustomerForm.vue?vue&type=style&index=1&id=e7c9d4f8&lang=scss"

import exportComponent from "/var/www/twledodo-booking-fondueretro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7c9d4f8"]])

export default __exports__